import { defineNuxtPlugin } from '#app'
import DocumentContent from '../components/document/content'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('document-content', DocumentContent)
})
